// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"49":"a4ba5517","384":"8e0b5ea8","714":"8749d349","993":"69524a0c"}[chunkId] + ".chunk.js";
};